const SCAN_EVENT_QUEUE_CONSUMER_ALREADY_SUBSCRIBED_ERROR_NAME =
  'ScanEventQueueConsumerAlreadySubscribedError';

/**
 * Creates the error thrown when a second consumer attempts to subscribe.
 */
export const createScanEventQueueConsumerAlreadySubscribedError = (): Error => {
  const error = new Error('A scan event queue consumer is already subscribed.');
  error.name = SCAN_EVENT_QUEUE_CONSUMER_ALREADY_SUBSCRIBED_ERROR_NAME;
  return error;
};

/**
 * Type guard for {@link createScanEventQueueConsumerAlreadySubscribedError} results.
 */
export const isScanEventQueueConsumerAlreadySubscribedError = (error: unknown): error is Error =>
  error instanceof Error && error.name === SCAN_EVENT_QUEUE_CONSUMER_ALREADY_SUBSCRIBED_ERROR_NAME;
